function l(o, s = "default", n = []) {
  const t = o.$slots[s];
  return t === void 0 ? n : t();
}
export {
  l as getSlot
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/get-slot.js
// module id = 901
// module chunks = 41